import { render, staticRenderFns } from "./DocumentGroupForm.vue?vue&type=template&id=373264b2&"
import script from "./DocumentGroupForm.vue?vue&type=script&lang=js&"
export * from "./DocumentGroupForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentGroupForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports